import { Component, EventEmitter, Output } from '@angular/core';
import { NvPillComponent } from '../nv-pill/nv-pill.component';

/**
 *
 * @extends NvPillComponent
 */
@Component({
  selector: 'nv-pill-button',
  template: require('./nv-pill-button.component.html'),
  styles: [require('./nv-pill-button.scss')],
})
export class NvPillButtonComponent extends NvPillComponent {
  // Inputs inherited

  /**
   *
   *
   */
  @Output() clickButton: EventEmitter<any> = new EventEmitter<any>();

  get usesDarkRipple() {
    return !this.isInverted;
  }

  handleClick(event?: Event) {
    if (this.isDisabled !== true) {
      this.clickButton.emit(true); // Emit the `press` event
    } else {
      return false;
    }
  }
}
